<template>
	<div>
		<module-field :bind="$props">
			<div class="input-box">
				<span class="left"><input type="text" id="current-gps" readonly v-model="inputVal" :placeholder="field.placeholder"></span>
				<span class="right">
					<GmapMap id="current-gps-map" class="input-map" ref="map" :center="currentCoords" :zoom="zoom" :options="mapOptions">
						<GmapMarker v-if="zoom !== defaultZoom" :position="currentCoords" />
					</GmapMap>
					<a v-if="!fetchingLocation" @click.prevent="getCurrentGPS()" href class="get-current-gps">Get Current GPS<span class="fa fa-map-marker"></span></a>
					<a v-else class="loading-gps">Fetching Location<span class="fa fa-sync fa-spin"></span></a>
				</span>
			</div>
		</module-field>
	</div>
</template>

<style>
	.input-map{width:100%; height:300px;}
</style>

<script>
import CrudField from '@/mixins/CrudField';

export default {

	mixins: [ CrudField ],

	data() {
		return {
			fetchingLocation: false,
			mapOptions: {
				disableDefaultUI: true
			},
			defaultZoom: 4,
		};
	},

	computed: {
		currentCoords: function() {
			let lat = 39.8283, lng = -98.5795;
			if (typeof this.inputVal === 'string' && this.inputVal.indexOf(',') !== -1) {
				[ lat, lng ] = this.inputVal.split(', ').map(parseFloat);
			}

			return { lat, lng };
		},

		zoom: function() {
			if (!this.inputVal || this.inputVal.indexOf(',') === -1) {
				return this.defaultZoom;
			}

			return 14;
		}
	},

	methods: {
		getCurrentGPS() {
			this.fetchingLocation = true;
			navigator.geolocation.getCurrentPosition(
				this.getPositionSuccess.bind(this),
				this.getPositionFailure.bind(this),
				{ timeout: 10000, maximumAge: 60000, enableHighAccuracy: true }
			);
		},

		getPositionSuccess(position) {
			this.fetchingLocation = false;
			this.inputVal = position.coords.latitude + ', ' + position.coords.longitude;
			// this.$emit('input', this.inputVal);
		},

		getPositionFailure() {
			alert('We were unable to locate your position');
			this.fetchingLocation = false;
		},
	}
};
</script>
